import { c as _c } from "react/compiler-runtime";
import type { ContentSegment } from "./media-utils";
import MediaThumbnail from "./MediaThumbnail";
interface ContentSegmentComponentProps {
  readonly segment: ContentSegment;
  readonly index: number;
  readonly linkify?: boolean;
}
const URL_REGEX = /(https?:\/\/[^\s<]+[^\s<.,;:!?)\]"'])/g;
function linkifyText(text: string, segmentIndex: number): React.ReactNode[] {
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match;
  let partIndex = 0;
  const regex = new RegExp(URL_REGEX.source, "g");
  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(<span key={`${segmentIndex}-text-${partIndex++}`}>
          {text.slice(lastIndex, match.index)}
        </span>);
    }
    parts.push(<a key={`${segmentIndex}-link-${partIndex++}`} href={match[0]} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()} className="tw-text-iron-200/90 tw-underline tw-decoration-white/20 tw-underline-offset-2 tw-transition-colors tw-duration-300 hover:tw-text-iron-50 hover:tw-decoration-white/45">
        {match[0]}
      </a>);
    lastIndex = regex.lastIndex;
  }
  if (lastIndex < text.length) {
    parts.push(<span key={`${segmentIndex}-text-${partIndex}`}>
        {text.slice(lastIndex)}
      </span>);
  }
  return parts.length > 0 ? parts : [text];
}

/**
 * Component to render a single segment of content (text or media)
 */
export default function ContentSegmentComponent(t0) {
  const $ = _c(10);
  const {
    segment,
    index,
    linkify: t1
  } = t0;
  const linkify = t1 === undefined ? true : t1;
  if (segment.type === "text") {
    const t2 = `segment-${index}`;
    let t3;
    if ($[0] !== index || $[1] !== linkify || $[2] !== segment.content) {
      t3 = linkify ? linkifyText(segment.content, index) : segment.content;
      $[0] = index;
      $[1] = linkify;
      $[2] = segment.content;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== t2 || $[5] !== t3) {
      t4 = <span key={t2}>{t3}</span>;
      $[4] = t2;
      $[5] = t3;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  if (segment.mediaInfo) {
    const t2 = `segment-${index}`;
    let t3;
    if ($[7] !== segment.mediaInfo || $[8] !== t2) {
      t3 = <MediaThumbnail key={t2} media={segment.mediaInfo} />;
      $[7] = segment.mediaInfo;
      $[8] = t2;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    return t3;
  }
  return null;
}